import zones from 'zones';

const getHrefPath = (href: string): string => {
  return href.split(/[?#]/)[0].replace(/\/+$/, '') || '/';
};

export const matchesPathPrefix = ({ pathname, prefix }: { pathname: string; prefix: string }): boolean =>
  pathname === prefix || pathname.startsWith(`${prefix}/`);

const isSanityZonePage = (pathname: string): boolean => zones.sanity.pages.includes(pathname);

const isSanityZoneNestedPath = (pathname: string): boolean =>
  zones.sanity.pathPrefixes.some(({ prefix }) => pathname.startsWith(`${prefix}/`));

/** Whether this path is served by the Sanity zone (an exact zone page or a nested prefix path). */
export const isSanityZonePath = (pathname: string): boolean =>
  isSanityZonePage(pathname) || isSanityZoneNestedPath(pathname);

/**
 * Whether a link target is a site-relative path served by a different zone. The Next.js router
 * can only prefetch and soft-navigate within its own zone, so these have to be plain anchors.
 * See https://nextjs.org/docs/pages/guides/multi-zones#linking-between-zones
 */
export const isCrossZoneHref = (href: string): boolean => {
  /* Absolute URLs, protocol-relative URLs, hashes and `mailto:`/`tel:` are never soft navigations. */
  if (!href.startsWith('/') || href.startsWith('//')) return false;

  const pathname = getHrefPath(href);

  if (matchesPathPrefix({ pathname, prefix: zones.sanity.assetPrefix })) return true;

  return isSanityZonePath(pathname);
};
